// extracted by mini-css-extract-plugin
export var title1 = "typography-module--title1--S3KWp";
export var title2 = "typography-module--title2--1k2zH";
export var title3 = "typography-module--title3--qPf27";
export var large = "typography-module--large--1LztK";
export var base = "typography-module--base--6p3g7";
export var small = "typography-module--small--3QN38";
export var micro = "typography-module--micro--3mw-q";
export var paragraph = "typography-module--paragraph--fRZc3";
export var blockQuote = "typography-module--blockQuote--2yW6A";
export var responsiveTitle1 = "typography-module--responsiveTitle1--2OKuv";
export var responsiveTitle2 = "typography-module--responsiveTitle2--2TF2Z";
export var responsiveTitle3 = "typography-module--responsiveTitle3--MUns9";
export var responsiveTitle4 = "typography-module--responsiveTitle4--3Lq7Y";